module.exports = __webpack_public_path__ + "media/26.0ab9732c.wav";